<template>
  <div class="inner-container processus-page" :class="{ 'min-container': !getTabs }">
   
 <div class="page-header">
          <h1>{{  "Processus Dossier" }}</h1>

   
    <b-button variant="primary"    class="button-succes-style ml-2 float-right mb-2" @click="openCreateModal">
          <font-awesome-icon icon="plus-circle"  />
          {{ "Ajouter processus" }}
        </b-button>
        <b-button variant="info"                 class="button-succes-style ml-2 float-right mb-2"
 @click="openImportModal">
          <font-awesome-icon icon="file-import" class="mr-1" />
          {{  "Importer" }}
        </b-button>
    
    </div>
    <div class="content">
      <!-- Filtres -->
      <div class="d-flex align-items-center mb-3" style="gap: 1rem;">
        <b-form-input
          v-model="search"
          :placeholder="$t('SEARCH') || 'Rechercher...'"
          size="sm"
          style="max-width: 250px;"
          @input="onSearchInput"
        />
      </div>

      <!-- Tableau -->
      <div class="table-responsive">
        <table class="table table-hover table-striped">
          <thead class="thead-dark">
            <tr>
             
              <th>{{ $t("NAME") || "Nom" }}</th>
             <!-- <th>{{  "Description" }}</th>-->
              <th>{{ $t("ACTIVE") || "Actif" }}</th>
              <th>{{ $t("CREATED_AT") || "Créé le" }}</th>
              <th>{{  "Actions" }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="getProcessusLoading && !getProcessus.length">
              <td colspan="6" class="text-center py-4">
                <b-spinner small />
              </td>
            </tr>
            <tr v-else-if="!getProcessus.length">
              <td colspan="6" class="text-center text-muted py-4">
                {{  "Aucun processus trouvé." }}
              </td>
            </tr>
            <tr v-for="item in getProcessus" :key="item.id">
             
              <td>{{ item.nom || item.name || '-' }}</td>
              <!--<td>{{ item.description || '-' }}</td>-->
              <td>
                <b-form-checkbox
                  :checked="!!item.is_active_for_current_entreprise"
                  switch
                  size="lg"
                  :disabled="togglingActiveId === item.id"
                  @click.native.prevent="onActiveToggle(item, !item.is_active_for_current_entreprise)"
                />
                <b-spinner v-if="togglingActiveId === item.id" small class="ml-2 align-middle" />
              </td>
              <td>{{ formatDate(item.created_at) }}</td>
              <td>
                <b-button
                  size="sm"
                  variant="outline-primary"
                  class="mr-1"
                  :title="$t('EDIT_PIPELINE') || 'Modifier le pipeline'"
                  @click="goToPipeline(item)"
                >
                  <font-awesome-icon icon="columns" />
                </b-button>
                <b-button
                  size="sm"
                  variant="outline-secondary"
                  class="mr-1"
                  :title="$t('EDIT') || 'Modifier'"
                  @click="openEditModal(item)"
                >
                  <font-awesome-icon icon="edit" />
                </b-button>
                <b-button
                  size="sm"
                  variant="outline-danger"
                  :title="$t('DELETE') || 'Supprimer'"
                  @click="confirmDelete(item)"
                >
                  <font-awesome-icon icon="trash" />
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div v-if="totalPages > 1" class="d-flex justify-content-center mt-3">
        <b-pagination
          v-model="currentPage"
          :total-rows="getProcessusTotal"
          :per-page="perPage"
          @change="onPageChange"
        />
      </div>
    </div>

    <!-- Section Documents -->
    <div class="documents-section mt-5">
      <div class="page-header d-flex flex-wrap align-items-center justify-content-between mb-3">
        <h2>{{ $t("DOCUMENTS") || "Documents" }}</h2>
        <b-button variant="success" @click="openImportModal">
          <font-awesome-icon icon="file-import" class="mr-1" />
          {{  "Importer des documents" }}
        </b-button>
      </div>

      <div class="content">
        <!-- Filtres -->
        <div class="d-flex align-items-center mb-3" style="gap: 1rem;">
          <b-form-input
            v-model="documentSearch"
            :placeholder=" 'Rechercher des documents...'"
            size="sm"
            style="max-width: 250px;"
            @input="onDocumentSearchInput"
          />
          <multiselect
            v-model="documentCategoryFilter"
            :options="getDocumentCategories || []"
            :placeholder=" 'Filtrer par catégorie'"
            size="sm"
            style="max-width: 300px;"
            label="label"
            track-by="id"
            :searchable="true"
            :close-on-select="false"
            :clear-on-select="false"
            :loading="getDocumentCategoriesLoading"
            :internal-search="false"
            :options-limit="10"
            :limit="3"
            :max-height="200"
            :show-no-results="false"
            :hide-selected="false"
            :multiple="true"
            @input="onDocumentCategoryChange"
          >
            <template #noResult>
              {{  'Aucun résultat trouvé' }}
            </template>
            <template #noOptions>
              {{  'Aucune catégorie disponible' }}
            </template>
          </multiselect>
          <b-spinner v-if="documentsLoading" small />
        </div>

        <!-- Tableau des documents -->
        <div class="table-responsive">
          <table class="table table-hover table-striped">
            <thead class="thead-dark">
              <tr>
           
                <th>{{ $t("NAME") || "Nom" }}</th>
                <th>{{  "Catégorie" }}</th>
                <th>{{ $t("DATE") || "Date" }}</th>
                <th>{{ "Actions" }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="documentsLoading && !documents.length">
                <td colspan="5" class="text-center py-4">
                  <b-spinner small />
                </td>
              </tr>
              <tr v-else-if="!documents.length">
                <td colspan="5" class="text-center text-muted py-4">
                  {{  "Aucun document trouvé." }}
                </td>
              </tr>
              <tr v-for="doc in documents" :key="doc.id">
             
                <td>{{ doc.name || doc.filename || '-' }}</td>
                <td>
                  <span v-if="doc.category" class="badge badge-primary">{{ doc.category.label || doc.category.titre || '-' }}</span>
                  <span v-else class="text-muted">-</span>
                </td>
                <td>{{ formatDate(doc.created_at) }}</td>
                <td>
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    :title="$t('DOWNLOAD') || 'Télécharger'"
                    @click="downloadDocument(doc)"
                  >
                    <font-awesome-icon icon="download" />
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div v-if="totalDocumentPages > 1" class="d-flex justify-content-center mt-3">
          <b-pagination
            v-model="processusCurrentPage"
            :total-rows="totalDocuments"
            :per-page="documentPerPage"
            @change="onPageChange"
          />
        </div>
      </div>
    </div>

    <!-- Modal Créer/Modifier -->
    <b-modal
      id="processusModal"
      ref="processusModal"
      :title="isEditing ? ( 'Modifier le processus') : ( 'Ajouter un processus')"
      hide-footer
      @hidden="resetModal"
    >
      <b-form @submit.prevent="submitForm">
        <b-form-group :label="$t('NAME') || 'Nom'" label-for="processus-nom">
          <b-form-input
            id="processus-nom"
            v-model="form.nom"
            :placeholder="'Entrez le nom'"
            required
          />
        </b-form-group>
     <!--   <b-form-group :label=" 'Description'" label-for="processus-description">
          <b-form-textarea
            id="processus-description"
            v-model="form.description"
            :placeholder="'Entrez la description'"
            rows="3"
          />
        </b-form-group>-->
        <div class="d-flex justify-content-end mt-3">
          <b-button variant="secondary" class="mr-2" @click="$refs.processusModal.hide()">
            {{ $t("CANCEL") || "Annuler" }}
          </b-button>
          <b-button variant="primary" class="btn btn-primary text-white" type="submit" :disabled="saving">
            <b-spinner v-if="saving" small class="mr-1" />
            {{ isEditing ? ( 'Modifier') : ( 'Créer') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- Modal Import Documents Complémentaires -->
    <b-modal
      id="importDocumentsModal"
      ref="importDocumentsModal"
      :title=" 'Importer des documents complémentaires'"
      hide-footer
      @hidden="resetImportModal"
    >
      <b-form @submit.prevent="submitImport">
        <b-form-group :label=" 'Sélectionner les fichiers'" label-for="import-files">
          <b-form-file
            id="import-files"
            v-model="importFiles"
            accept="application/pdf,.pdf"
            :placeholder=" 'Choisir les fichiers PDF'"
            multiple
            required
          />
          <small class="form-text text-muted">
            {{  'Seuls les fichiers PDF sont acceptés' }}
          </small>
        </b-form-group>
        
        <b-form-group :label=" 'Catégorie '" label-for="import-category">
          <multiselect
            id="import-category"
            v-model="importCategory"
            :options="getDocumentCategories || []"
            :placeholder=" 'Sélectionner une catégorie'"
            label="label"
            track-by="id"
            :searchable="true"
            :close-on-select="true"
            :clear-on-select="false"
            :loading="getDocumentCategoriesLoading"
            :internal-search="false"
            :options-limit="10"
            :limit="1"
            :max-height="200"
            :show-no-results="false"
            :hide-selected="true"
            :multiple="false"
          >
            <template #noResult>
              {{ $t('NO_RESULTS_FOUND') || 'Aucun résultat trouvé' }}
            </template>
            <template #noOptions>
              {{ $t('NO_CATEGORIES_AVAILABLE') || 'Aucune catégorie disponible' }}
            </template>
          </multiselect>
        </b-form-group>
        
        <div class="d-flex justify-content-end mt-3">
          <b-button variant="secondary" class="mr-2" @click="$refs.importDocumentsModal.hide()">
            {{ $t("CANCEL") || "Annuler" }}
          </b-button>
          <b-button variant="success" type="submit" :disabled="importSaving || !hasImportFiles">
            <b-spinner v-if="importSaving" small class="mr-1" />
            {{ $t("IMPORT") || "Importer" }}
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import domain from "@/environment";

export default {
  name: "ProcessusDossier",
  data() {
    return {
      search: "",
      processusCurrentPage: 1,
      perPage: 10,
      searchTimeout: null,
      form: {
        id: null,
        nom: "",
        description: "",
        active: false,
      },
      isEditing: false,
      saving: false,
      togglingActiveId: null,
      // Import documents complémentaires
      importModal: false,
      importFiles: null,
      importCategory: null,
      importSaving: false,
      // Gestion des documents
      documents: [],
      documentsLoading: false,
      documentSearch: "",
      documentCategoryFilter: [],
      currentDocumentPage: 1,
      documentPerPage: 10,
      totalDocuments: 0,
    };
  },
  computed: {
    ...mapGetters(["getTabs", "getOnlineUser", "getProcessus", "getProcessusLoading", "getProcessusTotal", "getAllgallery", "getLoadinggallery", "getDocumentCategories", "getDocumentCategoriesLoading"]),
    totalPages() {
      return Math.ceil(this.getProcessusTotal / this.perPage);
    },
    isSuperAdmin() {
      return this.getOnlineUser?.role === "user.super-admin";
    },
    totalDocumentPages() {
      return Math.ceil(this.totalDocuments / this.documentPerPage);
    },
    currentDossierId() {
      return this.$route.params.id || this.getOnlineUser?.current_dossier?.id;
    },
  },
  mounted() {
    this.loadProcessus();
    // Charger les galleries pour l'import de documents
    this.loadGalleries();
    // Charger les documents
    this.loadDocuments();
    // Charger les catégories de documents
    this.loadDocumentCategories();
  },
  methods: {
    ...mapActions(["fetchProcessus", "createProcessus", "updateProcessus", "deleteProcessus", "toggleProcessusActive", "allgallery", "importComplementairesDocuments", "fetchDocumentCategories", "fetchDocuments"]),
    async loadProcessus() {
      try {
        const params = {
          page: this.processusCurrentPage,
          per_page: this.perPage,
          search: this.search || undefined,
        };
        
        // Ne pas passer entreprise_id si l'utilisateur est super-admin
        if (!this.isSuperAdmin) {
          params.entreprise_id = this.getOnlineUser?.entreprise?.id || undefined;
        }
        
        await this.fetchProcessus(params);
      } catch (err) {
        console.error("Erreur lors du chargement des processus:", err);
      }
    },
    onSearchInput() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1;
        this.loadProcessus();
      }, 400);
    },
    onPageChange(page) {
      this.processusCurrentPage = page;
      this.loadProcessus();
    },
    formatDate(dateStr) {
      if (!dateStr) return "-";
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return dateStr;
      return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" });
    },
    openCreateModal() {
      this.isEditing = false;
      this.form = { id: null, nom: "", description: "", active: false };
      this.$refs.processusModal && this.$refs.processusModal.show();
    },
    openEditModal(item) {
      this.isEditing = true;
      this.form = {
        id: item.id,
        nom: item.nom || item.name || "",
        description: item.description || "",
        active: item.is_active_for_current_entreprise !== undefined ? item.is_active_for_current_entreprise : true,
      };
      this.$refs.processusModal && this.$refs.processusModal.show();
    },
    resetModal() {
      this.form = { id: null, nom: "", description: "", active: false };
      this.isEditing = false;
      this.saving = false;
    },
    async submitForm() {
      if (!this.form.nom?.trim()) {
        console.warn("Le nom est requis");
        return;
      }
      this.saving = true;
      try {
        if (this.isEditing) {
          await this.updateProcessus({
            id: this.form.id,
            nom: this.form.nom.trim(),
            description: this.form.description?.trim() || null,
            active: this.form.active,
            is_global: this.isSuperAdmin,
          });
        } else {
          await this.createProcessus({
            nom: this.form.nom.trim(),
            description: this.form.description?.trim() || null,
            active: false,
            is_global: this.isSuperAdmin,
            entreprise_id: this.isSuperAdmin ? null : (this.getOnlineUser?.entreprise?.id || null),
          });
        }
        this.$refs.processusModal && this.$refs.processusModal.hide();
        await this.loadProcessus();
      } catch (err) {
        console.error("Erreur lors de la soumission du formulaire:", err);
      } finally {
        this.saving = false;
      }
    },
    async confirmDelete(item) {
      const confirmed = await this.$bvModal.msgBoxConfirm(
         `Supprimer le processus "${item.nom || item.name}" ?`,
        {
          title: this.$t("CONFIRM") || "Confirmer",
          okVariant: "danger",
          okTitle: this.$t("DELETE") || "Supprimer",
          cancelTitle: this.$t("CANCEL") || "Annuler",
        }
      );
      if (!confirmed) return;
      try {
        await this.deleteProcessus(item.id);
        await this.loadProcessus();
      } catch (err) {
        console.error("Erreur lors de la suppression:", err);
      }
    },
    goToPipeline(item) {
      // Si le processus est global, ne pas inclure entreprise_id dans l'URL
      if (item.is_global) {
        this.$router.push(`/pipeline/${item.id}`);
      } else {
        // Pour les processus non globaux, inclure l'entreprise_id dans l'URL
        const entrepriseId = this.getOnlineUser?.entreprise?.id;
        this.$router.push(`/pipeline/${item.id}?entreprise_id=${entrepriseId}`);
      }
    },
    async onActiveToggle(item, newActive) {
      const list = this.getProcessus || [];
      const hasOtherActive = list.some((p) => p.id !== item.id && p.is_active_for_current_entreprise);

      if (newActive) {
        if (hasOtherActive) {
          const msg = "Un autre processus est déjà actif. Toutes les données du pipeline vont changer vers le premier statut du nouveau processus. Continuer ?";
          const confirmed = await this.$bvModal.msgBoxConfirm(msg, {
            title: "Avertissement",
            okVariant: "warning",
            okTitle: "Confirmer",
            cancelTitle: "Annuler",
          });
          if (!confirmed) return;
        }
      } else {
        if (!hasOtherActive) {
          const msg = "Aucun autre processus ne sera actif. Les données du pipeline vont disparaître. Continuer ?";
          const confirmed = await this.$bvModal.msgBoxConfirm(msg, {
            title: "Avertissement",
            okVariant: "danger",
            okTitle: "Confirmer",
            cancelTitle: "Annuler",
          });
          if (!confirmed) return;
        }
      }

      this.togglingActiveId = item.id;
      try {
        // Utiliser l'API PUT /api/processus/{id} avec le bon format
        await this.toggleProcessusActive({
          id: item.id,
          active: newActive,
          entreprise_id: this.getOnlineUser?.entreprise?.id || null
        });
        
        await this.loadProcessus();
      } catch (err) {
        console.error("Erreur lors du changement d'état:", err);
      } finally {
        this.togglingActiveId = null;
      }
    },
    async loadGalleries() {
      try {
        await this.allgallery({
          page: 1,
          per_page: 1000,
          search: ''
        });
      } catch (err) {
        console.error("Erreur lors du chargement des galleries:", err);
      }
    },
    async loadDocumentCategories() {
      try {
        await this.fetchDocumentCategories({
          page: 1,
          per_page: 1000,
          search: ''
        });
      } catch (err) {
        console.error("Erreur lors du chargement des catégories de documents:", err);
      }
    },
    openImportModal() {
      this.resetImportModal();
      this.$refs.importDocumentsModal && this.$refs.importDocumentsModal.show();
    },
    resetImportModal() {
      this.importFiles = null;
      this.importCategory = null;
      this.importSaving = false;
    },
    get hasImportFiles() {
      return this.importFiles && (Array.isArray(this.importFiles) ? this.importFiles.length > 0 : this.importFiles instanceof File);
    },
    async submitImport() {
      if (!this.hasImportFiles) {
        console.warn("Veuillez sélectionner au moins un fichier");
        return;
      }
      
      this.importSaving = true;
      try {
        const formData = new FormData();
        
        // Ajouter les fichiers PDF
        const files = Array.isArray(this.importFiles) ? this.importFiles : [this.importFiles];
        files.forEach((file) => {
          formData.append('pdf[]', file);
        });
        
        // Ajouter category_id si sélectionné
        if (this.importCategory && this.importCategory.id) {
          formData.append('category_id', this.importCategory.id);
        }
        
        // Appel à l'API d'import (à implémenter dans le store)
        await this.importComplementairesDocuments(formData);
        
        this.$refs.importDocumentsModal && this.$refs.importDocumentsModal.hide();
        this.resetImportModal();
      } catch (err) {
        console.error("Erreur lors de l'import:", err);
      } finally {
        this.importSaving = false;
      }
    },
    async loadDocuments() {
      this.documentsLoading = true;
      try {
        const params = {
          page: this.currentDocumentPage,
          per_page: this.documentPerPage,
          search: this.documentSearch || undefined,
        };
        
        // Ajouter les category_ids si des filtres sont sélectionnés
        if (this.documentCategoryFilter && this.documentCategoryFilter.length > 0) {
          params.category_ids = this.documentCategoryFilter.map(cat => cat.id).join(',');
        }
        
        // Récupérer l'ID du dossier depuis les paramètres de route ou store
        const ocrdossierId = this.currentDossierId;
        
        if (!ocrdossierId) {
          throw new Error("ID du dossier non trouvé");
        }
        
        // Appel à l'API pour charger les documents
        const response = await this.fetchDocuments({
          ocrdossierId,
          params
        });
        
        // Mettre à jour les documents et le total
        this.documents = response.data || [];
        this.totalDocuments = response.total || response.length || 0;
        
      } catch (err) {
        console.error("Erreur lors du chargement des documents:", err);
        // En cas d'erreur, afficher des données vides
        this.documents = [];
        this.totalDocuments = 0;
      } finally {
        this.documentsLoading = false;
      }
    },
    onDocumentSearchInput() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.currentDocumentPage = 1;
        this.loadDocuments();
      }, 400);
    },
    onDocumentCategoryChange() {
      this.currentDocumentPage = 1;
      this.loadDocuments();
    },
    downloadDocument(doc) {
      // Implémenter le téléchargement du document
      if (doc.id) {
        const url = `${domain}/documents/${doc.id}/download`;
        window.open(url, '_blank');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.processus-page {
  padding: 20px;
}

.page-header h1 {
  margin: 0;
  font-size: 1.5rem;
  color: #24316d;
}

.content {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.table {
  margin-bottom: 0;
}

.table th {
  border-top: none;
  background-color: #24316d;
  color: #fff;
}

.table td {
  vertical-align: middle;
}

.table tbody tr:hover {
  background-color: #f8f9fa;
}

.documents-section {
  margin-top: 2rem;
}

.documents-section h2 {
  font-size: 1.3rem;
  color: #24316d;
  margin-bottom: 1rem;
}

.badge {
  font-size: 0.8rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
}
</style>
